<template>
  <div
    ref="panelGroup"
    class="cf-node-properties__panel-group row"
  >
    <GenericProps
      :node-id="node.id"
      :settings.sync="settings"
      :parameters="node.parameters"
      @update:settings="updateNodeParent"
    />

    <div class="cf-node-properties__field col-md-12">
      <legend class="cf-node-properties__legend">
        <span v-t="'ROUTER_ROUTES'" />
      </legend>
      <button
        type="button"
        class="btn btn-success btn-sm m-b-10"
        :disabled="orderedRoutesList.length >= 10"
        @click.stop.prevent="addRoute"
      >
        <i class="fa fa-plus" />
        <span v-t="'ROUTER_ADD_ROUTE'" />
      </button>

      <div
        v-if="orderedRoutesList.length == 0"
        class="text-center"
      >
        <span v-t="'ROUTER_NO_ROUTES'" />
      </div>
      <RoutePanel
        v-for="(route, index) in orderedRoutesList"
        :key="route.id"
        :index="index + 1"
        :route.sync="route"
        :open-options="true"
        :focus-element="focusElement(route)"
        :weight-sum="weightSum"
      >
        <SplitTestSetting
          :route.sync="route"
          @route-change="onRouteChange"
        />
      </RoutePanel>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import messages from '../../../../locales';
import RoutePanel from '../Form/RoutePanel';
import SplitTestSetting from './SplitTestSetting';
import nodePropsMixin from '@/modules/ivrs/mixins/nodePropsMixin';

import { 
  createSettingsHierarchy,
} from '../../../../helpers/node';
import { merge, cloneDeep } from 'lodash';

export default {
  name: 'SplitTestNodeProps',
  components: {
    RoutePanel,
    SplitTestSetting,
  },

  mixins: [nodePropsMixin],

  props: {
    routes: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
      orderedRoutesList: cloneDeep(this.routes),
    };
  },
  computed: {
    weightSum() {
      return this.orderedRoutesList.reduce((result, item) => {
        return result + item.weight;
      }, 0);
    }
  },
  watch: {
    routes(newValue) {
      this.orderedRoutesList = cloneDeep(newValue);
    },
  },
  created() {
    this.buildNodeSettings();
  },
  methods: {

    onRouteChange() {
      this.$emit('update:routes', this.orderedRoutesList);
    },

    addRoute(event) {
      if (this.orderedRoutesList.length >= 10) {
        return;
      }
      this.$emit('showContextMenu', event, {
        node: this.node,
        slotNumber: 0,
        isOnFailure: false,
        filter: 'Route: ' + (this.orderedRoutesList.length + 1),
      });
    },
    focusElement(route) {
      return this.node.selectedLinkId === route.id;
    },

    buildNodeSettings() {
      // Sets value of settings data
      this.settings = createSettingsHierarchy(this.node, undefined, undefined, this.node.settings);
      // Merges built settings hierarchy with current node settings
      this.settings = merge(this.settings.root, this.node.settings);
      this.updateNodeParent();
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>